import { Component, OnInit } from '@angular/core';
import {CashbackService} from '../../../../core/service/cashback.service';
import {ClipboardService} from 'ngx-clipboard';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {ShopDetails} from '../../../../core/models/shopDetails';
import {Coupon} from '../../../../core/models/coupon';

@Component({
  selector: 'app-cashback-offer-details',
  templateUrl: './cashback-offer-details.component.html',
  styleUrls: ['./cashback-offer-details.component.scss'],
  providers: [TranslatePipe]
})
export class CashbackOfferDetailsComponent implements OnInit {
  public shop: ShopDetails;
  public shopCoupons: Array<Coupon> = [];
  public selectedCoupon: Coupon;
  public subdomain: string;
  public shopId: string;
  public offerId: string;

  constructor(private cashbackService: CashbackService,
    private clipboardService: ClipboardService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslatePipe,
    private toastrService: ToastrService) {

    this.subdomain = this.activeRoute.snapshot.params['subdomain'];
    this.shopId = this.activeRoute.snapshot.params['shopId'];
    this.offerId = this.activeRoute.snapshot.params['offerId'];
  }

  ngOnInit(): void {
    if (this.shopId && this.shopId !== '') {
      if (!this.offerId || this.offerId.trim() === '') {
        this.handleMissingOffer();
        return;
      }

      this.cashbackService.getShopDetails(this.shopId).subscribe({
        next: value => {
          this.shop = value;
          this.selectedCoupon = this.shop.coupons.find(c => c.slug === this.offerId);
          if (!this.selectedCoupon) {
            this.handleMissingOffer();
            return;
          }
          this.shopCoupons = this.shop.coupons.filter(c => c.slug !== this.offerId);
        },
        error: err => {
          this.toastrService.error(
            this.translate.transform('CASHBACK.DETAILS_PAGE.LOAD_FAILED'),
            this.translate.transform('ERROR'),
            { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
          );
          this.router.navigate([`${this.subdomain}/deals`]);
        }
      });
    }
  }

  getCode(selectedCoupon: Coupon) {
    if (selectedCoupon.code) {
      return selectedCoupon.code;
    }
    return this.translate.transform('CASHBACK.DETAILS_PAGE.NO_CODE');
  }

  visitCouponSite(selectedCoupon: Coupon) {
    window.open(this.shop.url, '_blank');
  }

  copyCode(selectedCoupon: Coupon) {
    if (selectedCoupon.code) {
      this.clipboardService.copy(selectedCoupon.code);
    }
  }

  pickCoupon(coupon: Coupon) {
    this.router.navigate([`/${this.subdomain}/deals/${this.shopId}/${coupon.slug}`]);

    this.selectedCoupon = this.shop.coupons.find(c => c.slug === coupon.slug);
    if (!this.selectedCoupon) {
      this.handleMissingOffer();
      return;
    }
    this.shopCoupons = this.shop.coupons.filter(c => c.slug !== coupon.slug);
  }

  handleMissingOffer() {
    this.router.navigate([`${this.subdomain}/deals/${this.shopId}`]);
    this.toastrService.error(
      this.translate.transform('CASHBACK.DETAILS_PAGE.OFFER_NOT_AVAILABLE'),
      this.translate.transform('ERROR'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
    );
  }

  loadCashback(shop: ShopDetails) {
    this.cashbackService.getCashbackLink(shop.id).subscribe({
      next: value => {
        window.open(value);
      },
      error: err => {
        this.toastrService.error(
          this.translate.transform('CASHBACK.DETAILS_PAGE.LOAD_FAILED'),
          this.translate.transform('ERROR'),
          {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
        );
      }
    });
  }
}
